export const downloadFilename = (url: string) => {
  try {
    const path = new URL(url).pathname;
    const last = path.split('/').pop();
    return last && last.length > 0 ? last : 'image';
  } catch {
    return 'image';
  }
};
